<template>
	<div id="spinner">
    <div class="spinner-bg">
      <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
        <image ref="fw1" class="animated-component" x="5" y="-20" width="16" height="16" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-firework.svg" />
        <image ref="fw2" class="animated-component" x="80" y="0" width="16" height="16" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-firework.svg" />
        <image ref="fs1" class="animated-component" x="4" y="80" width="18" height="18" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-free-service.svg" />
        <image x="72" y="90" width="14" height="14" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-discount.svg" />
        <image x="88" y="92" width="14" height="14" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-coin-alt.svg" />
        <image x="60" y="102" width="14" height="14" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-starbuck.svg" />
        <image x="80" y="98" width="14" height="14" transform="rotate(25 75 105)" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-grab.svg" />
        <image ref="gift1" class="animated-component" x="4" y="98" width="30" height="30" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gift.svg" />
        <image ref="star1" class="animated-component" x="80" y="-20" width="8" height="8" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg" />
        <image ref="star2" class="animated-component" x="0" y="84" width="8" height="8" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg" />
        <image ref="star3" class="animated-component" x="34" y="98" width="8" height="8" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg" />
        <image ref="star4" class="animated-component" x="94" y="86" width="8" height="8" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg" />
        <image ref="star5" class="animated-component" x="72" y="101" width="8" height="8" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg" />
      </svg>
    </div>
    <div class="title-container">
      <svg view-box="0 0 440 120">
        <image width="100%" height="100%" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/campaign-title.svg" />
      </svg>
    </div>
		<div class="wheel">
			<svg :viewBox="`0 0 ${wheel.diameter + wheel.strokeWidth * 2} ${wheel.diameter + wheel.strokeWidth * 2}`" :width="wheel.diameter + wheel.strokeWidth * 2" :height="wheel.diameter + wheel.strokeWidth * 2" preserveAspectRatio="xMidYMid meet">
        <g>
          <circle :cx="wheel.cx" :cy="wheel.cy" :r="wheel.diameter * 0.5" stroke="#97C9D1" :stroke-width="wheel.strokeWidth" />
        </g>
				<g ref="wheel" :transform-origin="`${wheel.cx} ${wheel.cy}`">
					<g class="sector" v-for="(award, index) in sectors" :key="index">
						<path class="sector__figure" :d="describeSector(index)" :fill="getSectorFill(index)" fill-rule="evenodd" />
							<image class="sector__img"
								:x="describeImage(index).x - 30"
								:y="describeImage(index).y - 20"
								:href="award.icon_url"
								:style="describeImage(index).style"
								width="60"
								height="60" />
					</g>
				</g>
        <image style="cursor: pointer;" @click="spin" :x="wheel.cx - 60" :y="wheel.cy - 60" width="120" height="120" href="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-start.svg" />
        <svg width="50" height="44" :x="wheel.cx - 25" :y="0" viewBox="0 0 50 44" fill="none">
          <path d="M28.4641 42C26.9245 44.6667 23.0755 44.6667 21.5359 42L0.751282 5.99999C-0.788319 3.33333 1.13618 -6.56032e-06 4.21539 -6.82951e-06L45.7846 -1.04636e-05C48.8638 -1.07328e-05 50.7883 3.33332 49.2487 5.99999L28.4641 42Z" fill="url(#paint0_linear_19_815)"/>
          <defs>
            <linearGradient id="paint0_linear_19_815" x1="25" y1="-16" x2="25" y2="48" gradientUnits="userSpaceOnUse">
              <stop stop-color="#3E678F"/>
              <stop offset="1" stop-color="#3580A9"/>
            </linearGradient>
          </defs>
        </svg>
			</svg>
  	</div>

    <div class="campaign-button-container">
      <div class="ticket-button bt">วันนี้คุณมีสิทธิ์เล่นเกม {{ remainingTickets }} สิทธิ์</div>
      <button class="campaign-button b1" @click="openTermModal()">เงื่อนไขกิจกรรม</button>
      <button class="campaign-button b2" @click="openRedeemedRewardsModal()">รางวัลของฉัน</button>
      <button class="campaign-button b3" @click="contactAdmin()">ติดต่อแอดมิน</button>
    </div>
    <sweet-modal ref="userDataModal" overlay-theme="dark">
      <div class="user-data-modal-content">
        <h2>กรุณากรอกข้อมูล</h2>
        <h3>เพื่อหมุนวงล้อรับของแถม</h3>
        <div class="user-data-modal-progress">
          <div class="progress"></div>
          <div class="dashed-line"></div>
          <div class="progress" :class="{ gray: !isBirthdayValid }"></div>
        </div>
        <form @submit.prevent="submitUserData">
          <label>
            เลือกเพศของคุณ
            <img class="check" src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check-disabled.png" v-if="gender === null">
            <img class="check" src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check.png" v-else>
            <div class="gender-selection">
              <input type="radio" id="male" v-model="gender" :value="1" />
              <label for="male" class="gender-option" :class="{ selected: gender === 1 }">
                <div>
                  <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-male.png" alt="Male">
                </div>
              </label>
              <input type="radio" id="female" v-model="gender" :value="2" />
              <label for="female" class="gender-option" :class="{ selected: gender === 2 }">
                <div>
                  <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-female.png" alt="Female">
                </div>
              </label>
              <input type="radio" id="lgbt" v-model="gender" :value="3" />
              <label for="lgbt" class="gender-option" :class="{ selected: gender === 3 }">
                <div>
                  <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-lgbt.png" alt="Lgbt">
                </div>
              </label>
              <input type="radio" id="unspecific" v-model="gender" :value="0" />
              <label for="unspecific" class="gender-option" :class="{ selected: gender === 0 }">
                <div>
                  <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-other.png" alt="Unspecific">
                </div>
              </label>
            </div>
          </label>
          <label>
            วันเดือนปีเกิด
            <img class="check" src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check-disabled.png" v-if="!isBirthdayValid">
            <img class="check" src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check.png" v-else>
            <input type="text" v-model="birthday" placeholder="ตัวอย่าง 07032541" class="birthday-input" />
          </label>
          <button type="submit" class="submit-button" :disabled="gender === null || !isBirthdayValid">หมุนวงล้อ</button>
        </form>
      </div>
    </sweet-modal>
    <sweet-modal ref="rewardModal" overlay-theme="dark">
      <div class="reward-modal-content" v-if="currentReward">
        <h2>รางวัลของคุณคือ</h2>
        <div class="reward-code">
          Code: <strong>{{ currentReward.reward_code }}</strong>
        </div>
        <div class="reward-icon">
          <svg viewBox="0 0 300 300" preserveAspectRatio="xMidYMid meet" width="300" height="300">
            <image x="0" y="0" width="300" height="300" :href="currentReward.image" />
          </svg>
        </div>
        <h1>{{ currentReward.title }}</h1>
        <div class="reward-description">
          สามารถใช้รางวัลนี้ตามเงื่อนไขที่กำหนด
        </div>
      </div>
      <div class="reward-modal-content" v-else>
        <h2>เกิดข้อผิดพลาด</h2>
      </div>
    </sweet-modal>
    <sweet-modal ref="redeemedRewardsModal" overlay-theme="dark">
      <div class="redeemed-rewards-modal-content">
        <h2>รางวัลของฉัน</h2>
        <template v-if="redeemedRewards && redeemedRewards.length">
          <div class="redeemed-reward-card" v-for="reward in redeemedRewards" :key="reward.id">
            <div class="redeemed-reward-card-content">
              <div class="redeemed-reward-card-icon">
                <svg viewBox="0 0 80 80" preserveAspectRatio="xMidYMid meet" width="80" height="80">
                  <image x="0" y="0" width="80" height="80" :href="reward.reward.image_alt" />
                </svg>
              </div>
              <div class="redeemed-reward-card-detail">
                <div class="title"><h3>{{ reward.reward.title }}</h3></div>
                <div class="redeemed-reward-card-footer">ใช้รางวัลได้ที่แอปพลิเคชันหรือตามที่เงื่อนไขกำหนด</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <span>คุณยังไม่มีรางวัล</span>
        </template>
      </div>
    </sweet-modal>
    <sweet-modal ref="termModal" overlay-theme="dark">
      <div class="term-modal-content">
        <h2>เงื่อนไขกิจกรรม</h2>
        <div class="term">
          <div class="term-subtitle">
            วิธีเข้าร่วมสนุก
          </div>
          <ol>
            <li>เพียงจองและใช้บริการในแอปพลิเคชั่น BeNeat</li>
            <li>คุณจะได้รับสิทธิ์ทุกการใช้บริการ 1 สิทธิ์หมุนวงล้อ ต่อ 1 การให้บริการที่เสร็จสิ้นแล้ว</li>
            <li>โดยเปิดแอปพลิเคชั่น BeNeat และไปที่แบนเนอร์ <strong>“กิจกรรมหมุนวงล้อ รับของแถม”</strong></li>
            <li>คุณจะได้รับรางวัลทุกครั้งที่หมุน </li>
            <li>ร่วมสนุกได้ตั้งแต่ วันที่ 28 มิถุนายน - 22 สิงหาคม 2567</li>
          </ol>
          <div class="term-subtitle">
            รายละเอียดของรางวัล
          </div>
          <ol>
            <li>ทำความสะอาดฟรี 2 ชม. มูลค่า 556.40 บาท</li>
            <li>GrabGifts Card มูลค่า 200 บาท</li>
            <li>Starbucks Card E-Coupon มูลค่า 100 บาท</li>
            <li>ส่วนลด Coin มูลค่า 5 Coin, 10 Coin, 20 Coin, 50 Coin และ 100 Coin</li>
            <li>ส่วนลดบริการ BeNeat 3%, 5%, 7%, 10%, 15%, 20% (สามารถใช้ได้ทุกบริการในแอปพลิเคชั่น BeNeat)</li>
          </ol>
          <div class="term-subtitle">
            เงื่อนไขการร่วมสนุกลุ้นรับรางรางวัล
          </div>
          <ol>
            <li>ผู้ที่ใช้บริการแอปพลิเคชัน BeNeat หลังจากเสร็จสิ้นการให้บริการ จะได้รับ 1 สิทธิ์ ต่อ 1 การใช้บริการในการหมุนวงล้อ</li>
            <li>
              บริการที่เข้าร่วม
              <ul>
                <li>บริการทำความสะอาดรายชั่วโมง</li>
                <li>บริการรีดผ้า</li>
                <li>บริการทำความสะอาดห้องน้ำ</li>
                <li>บริการทำความสะอาดทีม 3 คน</li>
                <li>บริการนวด</li>
                <li>บริการกำจัดไรฝุ่น</li>
                <li>บริการ Big Cleaning</li>
                <li>บริการซักโซฟา ที่นอน ผ้าม่าน</li>
                <li>บริการพ่นฆ่าเชื้อ</li>
              </ul>
            </li>
            <li>กรณีที่ได้รับรางวัลเป็นบริการทำความสะอาดฟรี 2 ชม. รายละเอียดการจองจะถูกส่งเข้าไปที่อีเมล์ที่ผู้โชคดีลงทะเบียนผ่านแอปไว้ และการจองจะปรากฏในหน้าใบงานในแอปของผู้โชคดีด้วย</li>
            <li>กรณีที่ได้รับเป็น GrabGifts Card และ Starbucks Card E-Coupon ทางบริษัทจะดำเนินการส่ง Link E-Coupon ให้กับท่านผ่านช่องทาง Email และ Line ที่ลงทะเบียนไว้กับ BeNeat</li>
            <li>กรณีที่ได้รับเป็นส่วนลด Coin และ ส่วนลดค่าบริการ BeNeat ผู้โชคดีจะได้รับผ่านแอปพลิเคชั่น BeNeat ทันทีในหน้าโปรไฟล์ หลังจากกดออกจากหน้ากิจกรรม</li>
            <li>ท่านสามารถเช็คของรางวัลที่ได้รับทั้งหมดจากกิจกรรมร่วมสนุก หมุนวงล้อ รับของแถม ได้ที่หน้ากิจกรรม และไปที่รางวัลของฉัน หรือสามารถติดต่อทางแอดมินเพื่อสอบถามเพิ่มเติมได้ที่ Line Official : @BeNeat</li>
            <li>บริษัทขอสงวนสิทธิ์ในการระงับหรือยกเลิกการให้สิทธิ์หรือรางวัลใด ๆ ในกิจกรรมนี้แก่บุคคลที่กระทำการใด ๆ โดยทุจริตหรือผิดกฎหมายหรือไม่ดำเนินการตามที่ระบุไว้ในเงื่อนไขและข้อกำหนดของกิจกรรมหรือเงื่อนไขอื่น ๆ ที่เกี่ยวข้องกับการใช้บริการแอปพลิเคชัน BeNeat หรือกระทำการใด ๆ อันเป็นการผิดวัตถุประสงค์ของกิจกรรม</li>
            <li>บริษัทมีสิทธิ์แต่เพียงผู้เดียวในการเพิกถอน เปลี่ยนแปลง และ/หรือ แก้ไขข้อกำหนดและเงื่อนไขของกิจกรรมนี้ได้ตลอดเวลา ซึ่งรวมถึงแต่ไม่จำกัดเพียงการเลื่อนหรือยกเลิกกิจกรรม โดยไม่จำเป็นต้องแจ้งให้ผู้เข้าร่วมกิจกรรมทราบล่วงหน้า และผู้เข้าร่วมกิจกรรมตกลงยอมรับเงื่อนไขการเปลี่ยนแปลงดังกล่าว</li>
            <li>บริษัทไม่ต้องรับผิดชอบต่อความเสียหาย การสูญเสีย การได้รับบาดเจ็บ หรือความผิดหวังที่เกิดขึ้นอันเนื่องมาจากการเข้าร่วมกิจกรรมหรือการรับมอบรางวัล หรือความเสียหายอื่นใดที่เกิดจากหรือเกี่ยวข้องกับกิจกรรมนี้ต่อผู้เข้าร่วมกิจกรรมหรือบุคคลที่สามไม่ว่ากรณีใด ๆ</li>
            <li>บริษัทจะไม่รับผิดชอบต่อการสูญหายหรือการถูกโจรกรรมข้อมูลของผู้เข้าร่วมกิจกรรม อันเนื่องมาจากปัญหาของระบบและ/หรือปัญหาทางเทคนิค รวมถึงแต่ไม่จำกัดเฉพาะการกระทำความผิดของบุคคลที่สาม</li>
            <li>รางวัลไม่สามารถขาย โอน หรือมอบสิทธิ์ให้แก่บุคคลหรือนิติบุคคลอื่นได้ และไม่สามารถเปลี่ยนเป็นเงินสดหรือสิ่งของอย่างอื่นได้ ไม่ว่ากรณีใด ๆ ทั้งสิ้น</li>
            <li>ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้บังคับของกฎหมายประเทศไทย และข้อพิพาทใด ๆ ที่เกิดขึ้นอันเกี่ยวกับข้อกำหนดและเงื่อนไขนี้จะอยู่ในเขตอำนาจของศาลไทย</li>
            <li>กรณีมีข้อพิพาทใด ๆ เกี่ยวกับกิจกรรมนี้ การพิจารณาและคำตัดสินของบริษัทให้ถือเป็นที่สุดและไม่อาจโต้แย้งได้</li>
            <li>เงื่อนไขเป็นไปตามที่บริษัทกำหนด</li>
          </ol>
        </div>
      </div>
    </sweet-modal>
    <sweet-modal class="image-modal" ref="imageModal" overlay-theme="dark">
      <div class="image-modal-content">
        <img src="https://beneat.s3-ap-southeast-1.amazonaws.com/news/news_1720162785768_51.png" alt="img" />
      </div>
    </sweet-modal>
	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import anime from 'animejs/lib/anime.es.js'
import { nextTick } from 'vue'
import { mapGetters } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0
  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  }
}
const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}
const WHEEL_SIZE = 400
const AWARDS = [
  { id: 1, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-starbuck.svg' },
  { id: 2, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-discount.svg' },
  { id: 3, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-free-service.svg' },
  { id: 4, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-coin.svg' },
  { id: 5, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-grab.svg' },
  { id: 6, icon_url: 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-coin.svg' }
]

export default {
  data () {
    return {
      sectors: AWARDS,
      spinning: false,
      currentAngle: 0,
      userId: null,
      validation: null,
      remainingTickets: 0,
      birthday: null,
      gender: null,
      currentReward: null,
      redeemedRewards: null
    }
  },
  components: {
    SweetModal
  },
  computed: {
    wheel () {
      const diameter = WHEEL_SIZE
      const strokeWidth = 20
      const center = WHEEL_SIZE / 2 + strokeWidth / 2

      return {
        diameter,
        radius: center - strokeWidth / 2, // space for stroke
        cx: center + strokeWidth / 2,
        cy: center + strokeWidth / 2,
        strokeWidth: strokeWidth
      }
    },
    sectorSize () {
      return 360 / this.sectors.length
    },
    isBirthdayValid () {
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.birthday)) {
        return moment(this.birthday, 'DD/MM/YYYY', true).isValid()
      }
      return false
    },
    ...mapGetters({
      user: 'auth/getUser'
    })
  },
  watch: {
    userId () {
      if (this.userId) {
        if (this.user && !this.validation) {
          this.getValidationCode()
        }
      }
    },
    validation () {
      if (this.validation && this.userId) {
        this.getCampaignData()
      }
    },
    birthday () {
      if (/[^0-9/]/.test(this.birthday)) {
        this.birthday = this.birthday.replace(/[^0-9/]/g, '')
      }
      if (/^\d{8}$/.test(this.birthday)) {
        this.birthday = this.birthday.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')
      }
    }
  },
  methods: {
    // Calculations
    describeSector (index) {
      const { cx, cy, radius } = this.wheel
      const { sectorSize } = this
      const startAngle = (index * sectorSize) - sectorSize / 2
      const endAngle = startAngle + sectorSize

      const start = polarToCartesian(cx, cy, radius, endAngle)
      const end = polarToCartesian(cx, cy, radius, startAngle)
      const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'

      const d = [
        'M', start.x, start.y,
        'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        'L', cx, cy,
        'Z'
      ].join(' ')

      return d
    },
    describeImage (index) {
      const { cx, cy, radius } = this.wheel
      const { sectorSize } = this

      const angle = index * sectorSize
      const offset = 50
      const position = polarToCartesian(cx, cy, radius - offset, angle)
      const style = `
        transform-origin: ${position.x}px ${position.y}px;
        transform: rotate(${angle}deg);
      `
      return { ...position, angle, style }
    },
    // Helpers
    openTermModal () {
      this.$refs.termModal.open()
    },
    async openRedeemedRewardsModal () {
      await this.getRedeemedRewards()
      this.$refs.redeemedRewardsModal.open()
    },
    async getRedeemedRewards () {
      this.redeemedRewards = null
      try {
        this.$swal.showLoading()
        const { data } = await axios.get(`/million-booking-celebrate/${this.userId}/redeemed-rewards`, { params: { validation: this.validation } })
        this.$swal.close()
        if (data.error) {
          this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          return
        }
        this.redeemedRewards = data.redeemed_rewards
      } catch (e) {
        console.error(e)
        this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    contactAdmin () {
      window.open('https://line.me/R/ti/p/%40hnk7011n')
    },
    showErrorMessage (message) {
      this.$swal({
        text: message,
        type: 'error',
        confirmButtonColor: '#2C94BB',
        confirmButtonText: 'ปิด'
      })
    },
    // Animations
    async move (sign) {
      this.currentAngle += sign ? this.sectorSize * -1 : this.sectorSize
      anime({
        targets: this.$refs.wheel,
        rotate: this.currentAngle
      })
    },
    async spin () {
      if (this.spinning) {
        return
      }
      if (!this.userId || !this.validation) {
        this.$swal({
          text: 'ขออภัยค่ะ URL ของคุณไม่ถูกต้อง กรุณาติดต่อแอดมินเพื่อแจ้งปัญหาการใช้งาน',
          type: 'warning',
          confirmButtonColor: '#2C94BB',
          reverseButtons: true,
          confirmButtonText: 'เงื่อนไขกิจกรรม',
          preConfirm: () => {
            this.$swal.close()
            this.openTermModal()
          }
        })
        return
      }
      if (this.remainingTickets <= 0) {
        this.$swal({
          text: 'ขออภัยค่ะ สิทธิ์ในการร่วมสนุกของคุณไม่พอ',
          type: 'warning',
          confirmButtonColor: '#2C94BB',
          reverseButtons: true,
          confirmButtonText: 'เงื่อนไขกิจกรรม',
          preConfirm: () => {
            this.$swal.close()
            this.openTermModal()
          }
        })
        return
      }
      if (!this.isBirthdayValid || this.gender == null) {
        this.$refs.userDataModal.open()
        return
      }

      let reward = null
      this.currentReward = null
      try {
        const { data } = await axios.post(`/million-booking-celebrate/${this.userId}/spin`, { validation: this.validation })
        if (data.error) {
          this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          return
        }
        reward = data.reward
        if (data.remaining_tickets != null) {
          this.remainingTickets = data.remaining_tickets
        }
      } catch (e) {
        console.error(e)
        this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        return
      }

      const { sectors, sectorSize, currentAngle } = this
      const awardIndex = sectors.findIndex(award => award.id === reward.id)
      const awardRandomOffset = getRandomInt((sectorSize / 2) * -1, (sectorSize / 2))
      const awardAngleCenter = awardIndex * this.sectorSize

      const turns = (10 * 360)
      const targetAngleUnvalidated = turns + awardAngleCenter

      const targetAngle = Math.abs(awardAngleCenter) > Math.abs(currentAngle)
        ? targetAngleUnvalidated
        : targetAngleUnvalidated + 360
      const targetAngleOffset = targetAngle + awardRandomOffset

      this.spinning = true

      await anime({
        targets: this.$refs.wheel,
        duration: 10000,
        rotate: -targetAngleOffset,
        easing: 'easeOutCirc'
      }).finished

      await anime({
        targets: this.$refs.wheel,
        delay: 250,
        rotate: -targetAngle
      }).finished

      // Trimming angle for future animations
      this.currentAngle = -targetAngle % 360

      anime.set(this.$refs.wheel, {
        rotate: this.currentAngle
      })

      this.currentReward = reward
      this.$refs.rewardModal.open()

      this.spinning = false
    },
    // View Helpers
    getSectorFill (index) {
      if (this.sectors.length % 2 === 0) {
        if (index % 2 === 0) {
          return '#F9F7EF'
        } else if (index === 1) {
          return '#5ACDDF'
        } else if (index === 3) {
          return '#6DB7D5'
        } else {
          return '#9AEDEA'
        }
      } else {
        return '#F9F7EF'
      }
    },
    // API
    openLoginModal () {
      if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'true')) {
        return
      }
      if (!this.user) {
        this.$parent.openModal('login')
      } else {
        this.userId = this.user.id
      }
    },
    async validateUser (userId, validation) {
      try {
        this.$swal.showLoading()
        const { data } = await axios.get(`/users/${userId}/validate`, { params: { validation } })
        if (!data.error) {
          this.userId = userId
          this.validation = validation
        } else {
          this.$swal.close()
          this.openLoginModal()
        }
      } catch (e) {
        this.$swal.close()
        this.openLoginModal()
      }
    },
    async getValidationCode () {
      try {
        const { data } = await axios.get(`/users/${this.userId}/validation-code`)
        if (!data.error) {
          this.validation = data.validation
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getCampaignData () {
      try {
        const { data } = await axios.get(`/million-booking-celebrate/${this.userId}`, { params: { validation: this.validation } })
        if (!data.error) {
          if (data.user) {
            this.gender = data.user.gender
            if (data.user.birthday) {
              this.birthday = moment(data.user.birthday).format('DDMMYYYY')
            }
          }
          this.remainingTickets = data.remaining_tickets
          this.$swal.close()
        }
      } catch (e) {
        console.error(e)
        this.$swal.close()
      }
    },
    async submitUserData () {
      try {
        this.$refs.userDataModal.close()
        let birthday = moment(this.birthday, 'DD/MM/YYYY')
        if (birthday.year() > 2400) {
          const year = birthday.year() - 543
          birthday = moment(birthday).set('year', year).format('YYYY-MM-DD')
        } else {
          birthday = birthday.format('YYYY-MM-DD')
        }
        const { data } = await axios.put(`/million-booking-celebrate/${this.userId}/info`, { gender: this.gender, birthday, validation: this.validation })
        if (!data.error) {
          this.spin()
        } else {
          this.$swal({
            text: 'ขออภัยค่ะ มีข้อผิดพลาดในการบันทึกข้อมูลของคุณ กรุณาลองใหม่อีกครั้ง',
            type: 'error',
            confirmButtonColor: '#2C94BB',
            confirmButtonText: 'ปิด'
          })
        }
      } catch (e) {
        console.error(e)
        this.$swal({
          text: 'ขออภัยค่ะ มีข้อผิดพลาดในการบันทึกข้อมูลของคุณ กรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonColor: '#2C94BB',
          confirmButtonText: 'ปิด'
        })
      }
    }
  },
  mounted () {
    anime.set(this.$refs.wheel, {
      rotate: this.currentAngle
    })
    const { user_id: userId, show_img: showImg, validation } = this.$route.query
    this.validateUser(userId, validation)
    if (showImg) {
      setTimeout(() => {
        this.$refs.imageModal.open()
      }, 800)
    }
  },
  async created () {
    nextTick(() => {
      anime({
        targets: this.$refs.fw1,
        scale: [1, 0.5, 1],
        opacity: [1, 0.5, 1],
        duration: 4000,
        easing: 'easeInOutSine',
        loop: true
      })
      anime({
        targets: this.$refs.fw2,
        scale: [1, 0.5, 1],
        opacity: [1, 0.5, 1],
        duration: 4000,
        delay: 1000,
        easing: 'easeInOutSine',
        loop: true
      })
      anime({
        targets: this.$refs.fs1,
        rotate: [0, 15, 0],
        duration: 4000,
        easing: 'easeInOutSine',
        loop: true
      })
      anime({
        targets: this.$refs.gift1,
        rotate: [0, 15, 0],
        duration: 4000,
        delay: 1000,
        easing: 'easeInOutSine',
        loop: true
      })
      anime({
        targets: [this.$refs.star1, this.$refs.star2, this.$refs.star3, this.$refs.star4, this.$refs.star5],
        opacity: [1, 0, 1],
        duration: 4000,
        easing: 'easeInOutSine',
        loop: true
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@400;700&display=swap');

#spinner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100dvh;
  color: #34495e;

  font-family: 'Kanit', sans-serif;
  user-select: none;

  @media (min-width: 768px) {
    width: 500px;
    margin: 0 auto;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
}

.spinner-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100dvh;
  background-color: #F5EFDA;

  @media (min-width: 768px) {
    width: 500px;
    margin: 0 auto;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
}

.title-container {
  position: relative;
  display: flex;
  justify-content: center;
}

.wheel {
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  height: auto;

  @media (min-width: 768px) {
    width: 440px;
  }
  @media (max-width: 767px) {
    width: 95%;
  }

  &__marker {
    position: absolute;
    top: -4px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid #2c3e50;
  }
}

.sector {
  stroke-width: 4px;
  transform-origin: 200 200;

  &__label {
    font-size: 24px;
    fill: #ecf0f1;
    stroke: none;
    font-weight: 700;
    text-anchor: middle;
    transform-origin: center;

    &.is-emoji {
      font-size: 38px;
    }
  }

	&__img {
    transform-origin: center;
  }
}

.buttons {
  display: flex;
}

.button {
  position: relative;
  min-width: 120px;
  border: none;
  outline: none;
  background-color: #e74c3c;
  color: #ecf0f1;
  text-align: center;
  cursor: pointer;

  &__title {
    text-transform: uppercase;
  }

  &:hover {
    background-color: lighten(#e74c3c, 10%);
  }

  &:active {
    background-color: #e74c3c;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.8;
    background-color: #bdc3c7;
    border-color: #95a5a6;
  }
}

.campaign-button-container {
  display: grid;
  z-index: 1;
  gap: 10px;
  margin: 0 20px 20px 20px;
  justify-content: space-between;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 50px 50px;
  grid-template-areas:
    "bt bt bt"
    "b1 b2 b3";

  .bt {
    grid-area: bt;
  }

  .b1 {
    grid-area: b1;
  }

  .b2 {
    grid-area: b2;
  }

  .b3 {
    grid-area: b3;
  }

  .ticket-button {
    background-color: #fff;
    border: 2px solid #2C94BB;
    color: #2C94BB;
    padding: 10px 20px;
    border-radius: 5px;
    text-align: center;
    font-size: 18px;
    flex-grow: 1;
    margin: 0 5px;
    font-weight: 400;
    vertical-align: middle;
  }

  .campaign-button {
    background-color: #2C94BB;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    flex-grow: 1;
    margin: 0 5px;

    &:hover {
      background-color: #056083;
    }

    @media (max-width: 767px) {
      padding: 10px 8px;
      font-size: 12px;
    }

  }
}

.animated-component {
  transform-origin: 50% 50%;
  transform-box: fill-box;
}

.user-data-modal-content {
  text-align: center;
  h2 {
    margin-bottom: 1rem;
    color: #2C94BB;
    font-weight: 400;
  }
  h3 {
    color: #2C94BB;
    font-weight: 400;
  }
  form {
    text-align: left;
  }
  .check {
    margin-left: 0.5rem;
  }
  .gender-selection {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 1em;

    input[type="radio"] {
      display: none;
    }

    .gender-option {
      cursor: pointer;
      div {
        width: 80px;
        height: 80px;
        display: flex;
        margin-right: 0.5rem;
        margin-top: 1rem;
        justify-content: center;
        align-items: center;
        border: 1px solid #9A9A9A;
        border-radius: 10px;
        transition: border-color 0.3s;
      }

      &.selected div {
        border-color: #2C94BB;
        border-width: 4px;
      }

      &:hover div,
      &:focus div {
        border-width: 4px;
        border-color: #2C94BB;
      }
    }
  }
  .birthday-input {
    width: calc(100% - 20px);
    padding: 8px;
    margin-top: 1rem;
    border: 1px solid #9A9A9A;
    border-radius: 5px;
    text-align: left;
    font-size: 16px;
    color: #5C546A;
    &::placeholder {
      color: #8A8895;
    }
  }
  .submit-button {
    width: 100%;
    margin-top: 2rem;
    background-color: #2C94BB;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 0;
    cursor: pointer;
    font-size: 1em;
    transition: background-color 0.3s;
    &:disabled {
      background-color: #D9D9D9;
      cursor: not-allowed;
    }
    &:hover:not(:disabled) {
      background-color: #056083;
    }
  }
}

.user-data-modal-progress {
  display: flex;
  align-items: center;
  width: 160px;
  margin: 1.6rem auto;
}

.progress {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #2C94BB;
  &.gray {
    background-color: #d3d3d3;
  }
}

.dashed-line {
  flex-grow: 1;
  border-top: 2px dashed #ccc;
  margin: 0 10px;
}

.reward-modal-content {
  text-align: center;
  h1 {
    color: #2C94BB;
    margin-bottom: 1rem;
  }
  h2 {
    margin-bottom: 1rem;
    color: #5C546A;
    font-weight: 400;
  }
  .reward-icon {
    margin-bottom: 1rem;
  }
  .reward-code {
    color: #2C94BB;
    margin-bottom: 1rem;
  }
  .reward-description {
    color: #2C94BB;
  }
}

.term-modal-content {
  text-align: center;
  h2 {
    margin-bottom: 1rem;
    color: #2C94BB;
    font-weight: 400;
  }
  .term {
    text-align: left;
    .term-subtitle {
      color: #2C94BB;
      font-weight: 400;
    }
    ol {
      padding-left: 2rem;
    }
    ul {
      padding-left: 2rem;
    }
  }
}

.redeemed-rewards-modal-content {
  text-align: center;
  h2 {
    margin-bottom: 1rem;
    color: #2C94BB;
    font-weight: 400;
  }
  h3 {
    margin-bottom: 1rem;
    color: #2C94BB;
    font-weight: 400;
  }
  .redeemed-reward-card {
    text-align: left;
    border: 2px solid #2C94BB;
    border-radius: 8px;
    padding: 16px;
    background-color: #ffffff;
    width: 80%;
    margin: 20px auto;

    &-title {
      font-size: 24px;
      font-weight: bold;
      color: #2C94BB;
      margin-bottom: 20px;

      @media (max-width: 767px) {
        font-size: 20px;
      }
    }

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-content {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 1rem;
      font-size: 16px;
      color: #5C546A;
    }

    &-detail {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      svg {
        margin-right: 1rem;
      }

      .title {
        font-size: 140%;
        color: #2C94BB;

        @media (max-width: 767px) {
          font-size: 100%;
        }
      }
    }

    &-footer {
      color: #5C546A;
      @media (max-width: 767px) {
        font-size: 14px;
      }
    }
  }
}

.image-modal .sweet-modal {
  background: rgba(255, 255, 255, 0.8);
}
.image-modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/campaign/millionBookingCelebrate/Index.vue